export default __webpack_public_path__ + "4160bce0454fd056bba698ce7db69756.png";